import { Document, Packer, Paragraph, TextRun } from "docx";
import { saveAs } from "file-saver";
import { notification } from "../utils/Notifications.tsx";
import { IContract } from "../interfaces/others/IContract.ts";

export const useDownloadContractDocx = () => {
  const handleDownloadContractDocx = async (contractData: IContract) => {
    try {
      const paragraphs: Paragraph[] = [];

      const pushP = (
        text: string,
        options: { bold?: boolean; center?: boolean } = {}
      ) => {
        paragraphs.push(
          new Paragraph({
            alignment: options.center ? "center" : undefined,
            children: [
              new TextRun({
                text,
                bold: options.bold,
              }),
            ],
          })
        );
      };

      pushP("CONTRATO INDIVIDUAL DE TRABAJO POR TIEMPO INDETERMINADO", {
        bold: true,
      });

      paragraphs.push(
        new Paragraph({
          children: [
            new TextRun({
              text: "QUE CELEBRAN LA PERSONA MORAL ",
            }),
            new TextRun({
              text: `${contractData?.bussinessName ?? ""} SAPI DE CV`,
              bold: true,
            }),
            new TextRun({
              text: " Y EL ",
            }),
            new TextRun({
              text: `C. ${(contractData?.firstName ?? "").toUpperCase()} ${(
                contractData?.lastName ?? ""
              ).toUpperCase()} ${(
                contractData?.secondLastName ?? ""
              ).toUpperCase()}`,
              bold: true,
            }),
            new TextRun({
              text: ", A QUIENES EN LO SUCESIVO SE LES DENOMINARÁ ",
            }),
            new TextRun({
              text: "EL PATRÓN",
              bold: true,
            }),
            new TextRun({
              text: " Y ",
            }),
            new TextRun({
              text: "EL TRABAJADOR",
              bold: true,
            }),
            new TextRun({
              text: " RESPECTIVAMENTE, ",
            }),
            new TextRun({
              text: "LAS PARTES",
              bold: true,
            }),
            new TextRun({
              text: " PARA AMBAS Y, AL HACER ALUSIÓN A LA ",
            }),
            new TextRun({
              text: "LEY FEDERAL DEL TRABAJO",
              bold: true,
            }),
            new TextRun({
              text: " SE DIRÁ ",
            }),
            new TextRun({
              text: "LA LEY",
              bold: true,
            }),
            new TextRun({
              text: ", DE CONFORMIDAD CON LAS SIGUIENTES DECLARACIONES Y CLÁUSULAS.",
            }),
          ],
        })
      );

      pushP("");
      pushP("D E C L A R A C I O N E S:", { bold: true, center: true });
      pushP("");

      pushP("I. DECLARA EL PATRÓN A TRAVÉS de SU REPRESENTANTE LEGAL;");
      pushP(
        "I. A. Ser una Persona Moral con personalidad jurídica y patrimonio propios; constituida en apego a las Leyes Mexicanas, lo que consta en el Instrumento Notarial 12,102, Volumen 185 de fecha 09 de Diciembre del 2019, pasado ante la Fe del Notario Público N°96 del Estado de Oaxaca Lic. Gustavo Manzano Trovamala Heredia."
      );
      pushP(
        "I. B. Para los efectos legales correspondientes es representada por el C. Roberto Espinosa Vásquez en su carácter de Presidente del Consejo de Administración y Representante Legal de la misma, personalidad que acredita con el Instrumento Notarial descrito en la declaración que antecede, con todas las facultades para celebrar todo tipo de actos jurídicos."
      );
      pushP(
        "I. C. Que el objeto social de su existencia es, entre otros: Establecer, comercializar, comprar, vender y administrar negocios de cafeterías, restaurantes, fuentes de soda y bares, así como sus insumos y equipos."
      );
      pushP(
        `I. D. Tiene su domicilio fiscal y principal asiento de operaciones en ${
          contractData?.bussinessDirection ?? ""
        }, y con RFC. ${contractData?.bussinessRFC ?? ""}.`
      );
      pushP(
        `I. E. Con fundamento en los Arts. 25, 31 y 35 de LA LEY, es su voluntad pactar con EL TRABAJADOR para que le brinde sus Servicios Personales Subordinados, con la categoría de ${
          contractData?.postionName ?? ""
        } y por Tiempo Indeterminado.`
      );

      pushP(
        "II. De EL TRABAJADOR, por SÍ MISMO y BAJO PROTESTA de DECIR VERDAD;"
      );
      pushP(
        `II. A. Ser de Nacionalidad ${contractData?.nacionalidad ?? ""} de ${
          contractData?.age ?? ""
        } años de edad; Sexo ${contractData?.genero ?? ""} de Estado Civil ${
          contractData?.estadoCivil ?? ""
        } de ocupación empleado; con CURP ${contractData?.curp ?? ""} con RFC ${
          contractData?.rfc ?? ""
        } Número de Seguridad Social ${
          contractData?.nss ?? ""
        } y con domicilio para los efectos legales consiguientes en ${
          contractData?.direccion?.replace(/&nbsp;/g, " ") ?? ""
        }.`
      );
      pushP(
        `II. B. Para los efectos legales a que haya lugar, se identifica con su Credencial de Elector expedida por el Instituto Nacional Electoral con IDMEX ${
          contractData?.idmex ?? ""
        } y OCR ${
          contractData?.ocr ?? ""
        }, la que se agrega al presente en copia simple; manifestando que la firma que aparece al reverso de la misma es la que usa para todos sus asuntos, y es la propia que estampa en el presente con las mismas características caligráficas, grafoscópicas y grafométricas.`
      );
      pushP(
        "II. C. Tener la capacidad, aptitudes y preparación suficientes para desarrollar con esmero y eficiencia los servicios requeridos por EL PATRÓN, en los términos descritos en la Declaración I.E."
      );
      pushP(
        "II. D. Que no padece discapacidad, ausencia, pérdida o restricción de habilidades para desarrollar una actividad neuromotora, intelectual, visual o auditiva en la forma o dentro del margen considerado como normal para todo ser humano, que le limite la capacidad de ejercer eficientemente las que EL PATRÓN le encomienda y para las que le contrata."
      );
      pushP(
        "II. E. Estar conforme en desempeñar los requerimientos de EL PATRÓN, y en plasmar las condiciones generales de trabajo sobre las cuales prestará sus servicios personales, por lo que se somete a las siguientes"
      );

      pushP("");
      pushP("C L A U S U L A S:", { bold: true, center: true });
      pushP("");

      pushP(
        "PRIMERA. LAS PARTES se reconocen mutuamente la personalidad con que se ostentan, para los efectos legales a que haya lugar, manifestando que es su libre voluntad signar este contrato."
      );
      pushP("A). Del OBJETO;");
      pushP(
        `SEGUNDA. EL TRABAJADOR prestará sus servicios personales subordinados a EL PATRÓN con la Categoría de ${
          contractData?.postionName ?? ""
        }, adscrito al Departamento de ${
          contractData?.positionDepartment ?? ""
        }, desempeñando el trabajo con esmero y eficiencia, con las funciones propias del puesto, que son, entre otras:`
      );

      if (Array.isArray(contractData?.positionFunctions)) {
        (contractData.positionFunctions as any[]).forEach((funcion) => {
          paragraphs.push(
            new Paragraph({
              text: `${funcion}`,
              bullet: { level: 0 },
            })
          );
        });
      }

      pushP(
        "funciones que se describen de manera enunciativa más no limitativa, y que desarrollará acatando las órdenes que le dé EL PATRÓN; lo anterior, en estricto apego a lo establecido en la Declaración I.E."
      );
      pushP(
        "II.1. EL TRABAJADOR prestará sus servicios en el Domicilio Fiscal de EL PATRÓN, sito en 2A PRIVADA DE CAMINO NACIONAL N°17, SAN SEBASTIAN TUTLA, OAX., C.P. 71320, en el propio de cualquiera de sus sucursales, o en otro futuro que le resulte por apertura de nuevos centros de trabajo o reubicación de los actuales."
      );

      pushP("B). De la VIGENCIA;");
      pushP(
        `TERCERA. LAS PARTES pactan que este contrato es por TIEMPO INDETERMINADO, según lo dispuesto por el Artículo 35 de LA LEY, surtiendo sus efectos a partir del ${
          contractData?.recruitmentDate ?? ""
        }, fecha que se toma como la de ingreso de EL TRABAJADOR a laborar para EL PATRÓN para los efectos de la antigüedad en el empleo.`
      );

      pushP("C). De la JORNADA de TRABAJO;");
      pushP(
        "CUARTA. La duración de la jornada será la máxima semanal de cuarenta y ocho horas para la diurna, quedando LAS PARTES en la disposición de repartir las horas de trabajo de acuerdo a las necesidades de EL PATRÓN y de conformidad con el Artículo 59 de LA LEY. Queda convenido que por cada seis días laborados EL TRABAJADOR disfrutará de un día de descanso semanal."
      );

      pushP("D). Del SALARIO;");
      pushP(
        `QUINTA. Por la prestación de sus servicios EL TRABAJADOR percibirá el pago de ${
          contractData?.monthlySalary ?? ""
        } M.N. mensual, pagaderos por periodo ${
          contractData?.periodicity ?? ""
        }, en moneda de curso legal y mediante pago en efectivo. EL PATRÓN retendrá del salario el importe de las cuotas que correspondan a EL TRABAJADOR por concepto de IMSS e INFONAVIT, así como las retenciones que mandata la Ley del Impuesto Sobre la Renta en sus Artículos 96 y 99.`
      );
      pushP(
        "V.1. En apego a lo dispuesto en el párrafo cuarto del Artículo 101 de LA LEY, contra el pago de su salario, EL TRABAJADOR se obliga a firmar los recibos CFDI o nómina correspondientes que para tal efecto destine EL PATRÓN y las autoridades competentes."
      );
      pushP(
        "V.2. EL TRABAJADOR gozará del pago y disfrute del periodo anual de Vacaciones, así como de la Prima Vacacional correspondiente, en términos de los Artículos 76, 78, 80 y 81 de LA LEY. Así también percibirá el pago del Aguinaldo equivalente a quince días de salario, o la parte proporcional al periodo que haya trabajado en el ejercicio fiscal, en apego a lo establecido en el Artículo 87 de LA LEY."
      );

      pushP("E). De las OBLIGACIONES de LAS PARTES;");
      pushP(
        "SEXTA. Son OBLIGACIONES de EL TRABAJADOR: VI.1. Con base en el Artículo 134 de LA LEY fracciones X y XI, EL TRABAJADOR se obliga a someterse a los exámenes médicos que las autoridades del Sector Salud Federal, Estatal o Municipal, la Comisión Mixta de Seguridad e Higiene, los reglamentos aplicables y/o EL PATRÓN indiquen, notificándole oportunamente si padece alguna enfermedad contagiosa. En particular, para el caso de EMERGENCIA SANITARIA decretada por las autoridades competentes, EL TRABAJADOR se someterá a todas las medidas sanitarias preventivas o restrictivas que se dicten."
      );
      pushP(
        "VI.2. En caso de que EL PATRÓN así lo requiera, EL TRABAJADOR se obliga a acatar las disposiciones que en materia de control de asistencia establezca, registrando su hora de entrada y salida a las labores, así como estampando su firma autógrafa en dichos registros."
      );
      pushP(
        "VI.3. Obedecer y acatar el REGLAMENTO INTERIOR DE TRABAJO que rige las relaciones laborales entre EL PATRÓN y sus TRABAJADORES, sujetándose a éste en todas sus partes."
      );
      pushP(
        "VI.4. Conservar en las mejores condiciones de uso, limpieza, estado y funcionamiento los instrumentos y útiles de trabajo que le proporcione EL PATRÓN, utilizándolos de manera correcta y exclusivamente para el desempeño de sus funciones laborales, obligándose a restituirlos en las mejores condiciones que uso y desgaste natural, en el tiempo en que EL PATRÓN lo requiera; lo anterior con base en el Artículo 134 Fracción VI de LA LEY."
      );
      pushP(
        "VI.5. Dada la naturaleza del Objeto Social de EL PATRÓN, si en términos del Artículo 75 de LA LEY EL TRABAJADOR es requerido para laborar en algún día de descanso obligatorio, queda obligado a prestar sus servicios, gozando del pago establecido en dicho ordenamiento."
      );
      pushP(
        "VI.6. En términos del Artículo 99 de la Ley del Impuesto Sobre la Renta fracciones IV y V, EL TRABAJADOR se obliga a proporcionar a EL PATRÓN los datos necesarios para inscribirlo en el Registro Federal de Contribuyentes; si ya estuviera inscrito, le proporcionará su clave de registro con la Constancia de Situación Fiscal. Adicionalmente, antes de que se efectúe el primer pago de salarios de cada ejercicio fiscal, EL TRABAJADOR se obliga a comunicar por escrito a EL PATRÓN si presta servicios a otro empleador, y si éste le aplica el Subsidio para el Empleo."
      );
      pushP(
        "VI.7. Participar en todas las capacitaciones y cursos de actualización que proporcione EL PATRÓN, aprobándolas, siendo prioritarias las aplicables a su Categoría, en apego al Artículo 153 de LA LEY."
      );
      pushP(
        "SÉPTIMA. EL TRABAJADOR queda obligado a guardar en estricta confidencialidad y secrecía los métodos administrativos, sistemas de trabajo, metodologías, políticas, secretos comerciales y de fabricación de productos, o cualquier otro de los que tenga conocimiento por razón del trabajo que se desempeña, así como de los asuntos administrativos reservados cuya divulgación cause perjuicio a EL PATRÓN o a terceros interesados."
      );
      pushP(
        "VII.1. Queda prohibido a EL TRABAJADOR reproducir copias de la documentación, planes de trabajo, manuales de procedimientos y/o archivos, ya sea en forma escrita o en cualquier medio digital, así como, en general, de todos los materiales de trabajo que le sean entregados por EL PATRÓN."
      );
      pushP(
        "VII.2. En caso de ser requerido por EL PATRÓN, EL TRABAJADOR manifiesta su disposición en firmar un CONVENIO DE CONFIDENCIALIDAD respecto de la Información, Datos, Conocimientos, Archivos digitales o impresos que reciba de EL PATRÓN para el ejercicio de sus funciones laborales."
      );
      pushP(
        "Por violación a lo dispuesto en esta cláusula, EL TRABAJADOR estará sujeto a la Rescisión de la Relación Laboral sin responsabilidad para EL PATRÓN, en términos del Artículo 47 de LA LEY."
      );
      pushP("OCTAVA. Son OBLIGACIONES de EL PATRÓN:");
      pushP(
        "VIII.1. Proporcionar capacitación y adiestramiento de acuerdo a la carga de trabajo y sus necesidades, en apego al TÍTULO CUARTO de los Derechos y Obligaciones de los Trabajadores y de los Patrones; Capítulo III BIS De la Productividad, Formación y Capacitación de los Trabajadores de LA LEY."
      );
      pushP(
        "VIII.2. Proporcionar a EL TRABAJADOR los instrumentos de trabajo necesarios para el buen desempeño de sus funciones."
      );

      pushP("F). CAUSAS de RESCISIÓN y VALIDEZ del CONTRATO;");
      pushP(
        "NOVENA. La violación a cualquiera de las obligaciones consignadas en este contrato por parte de EL TRABAJADOR, es causal de rescisión del mismo sin responsabilidad para EL PATRÓN, relacionadas a las enunciadas en el Artículo 47 de LA LEY."
      );
      pushP(
        "IX.1. Cualquier modificación al presente solo es válida si se hace por escrito entre LAS PARTES y se agrega como anexo a este contrato."
      );
      pushP(
        `DÉCIMA. Para los efectos de los Artículos 29, Fracción V del Código Fiscal de la Federación y 99, Fracción III de la Ley del Impuesto Sobre la Renta, en este acto, bajo protesta de decir verdad, EL TRABAJADOR manifiesta que su CORREO ELECTRÓNICO es ${
          contractData?.email ?? ""
        }, autorizando a EL PATRÓN para enviarle a dicho correo electrónico los archivos CFDI que correspondan al pago de sus salarios, eximiéndolo de cualquier responsabilidad por el manejo de dicha cuenta electrónica, así como del cumplir con las disposiciones de la ley de la materia.`
      );
      pushP(
        `DÉCIMA PRIMERA. En este acto, para la integración de su expediente personal, EL TRABAJADOR entrega a EL PATRÓN los siguientes documentos: 1). Original de Solicitud de Empleo; 2). Acta de Nacimiento; 3). Copia de la Credencial de Elector con Número Identificador OCR ${
          contractData?.ocr ?? ""
        } expedida por el I.N.E.; 4). Currículum Vitae; 5). Comprobante de Domicilio actual; 6). Constancia de Situación Fiscal con RFC; 7). Constancia oficial que acredita su último grado de estudios; 8). Clave Única de Registro de Población; 9). Constancia de Semanas Cotizadas en el IMSS; 10). Dos Cartas de Recomendación de fecha reciente a su contratación, expedidas por personas con solvencia moral reconocida por EL PATRÓN; 11). Croquis señalizado de la Ruta de Trayecto de su domicilio particular al CENTRO DE TRABAJO y viceversa; 12). Constancia de Trabajo de su Patrón inmediato anterior; 13). Certificado de Antecedentes Penales expedido por la Secretaría de Seguridad Pública de Oaxaca y/o autoridad competente, y cualesquier otro que le requiera EL PATRÓN.`
      );
      pushP(
        `DÉCIMA SEGUNDA. Para el caso de su fallecimiento o desaparición derivada de un acto delincuencial, en apego a lo establecido en los Artículos 25 Fracción X y 501 de LA LEY, EL TRABAJADOR designa como su beneficiario para el pago de los salarios y prestaciones devengadas y no cobradas, en primer lugar con derecho al 100%, al C. ${
          contractData?.firstNameFamiliar
            ? `${contractData.firstNameFamiliar} ${
                contractData.lastNameFamiliar ?? ""
              } ${contractData.secondLastNameFamiliar ?? ""}`
            : ""
        } en su calidad de ${
          contractData?.relationshipFamiliar ?? ""
        }, con número de teléfono ${
          contractData?.phoneFamiliar ?? ""
        }, y con domicilio en ${
          contractData?.addressFamiliar?.replace(/&nbsp;/g, " ") ?? ""
        }.`
      );

      pushP(
        `Para todo lo no previsto en el presente, su cumplimiento e interpretación, LAS PARTES se someten a lo establecido en LA LEY y a la jurisdicción de los Tribunales Laborales de la Ciudad de Oaxaca, Oax., firmando de aceptación al mismo en SAN SEBASTIÁN TUTLA, OAX., EL DÍA ${
          contractData?.todayDay ?? ""
        } DEL MES DE ${contractData?.todayMonth ?? ""} DEL AÑO ${
          contractData?.todayYear ?? ""
        }.`
      );

      pushP("");
      pushP("EL PATRÓN", { bold: true, center: true });
      pushP(
        `GRUPO ${(contractData?.bussinessName ?? "").toUpperCase()} SAPI DE CV`,
        { center: true }
      );
      pushP("");
      pushP("EL TRABAJADOR", { bold: true, center: true });
      pushP(
        `C. ${contractData?.firstName ?? ""} ${contractData?.lastName ?? ""} ${
          contractData?.secondLastName ?? ""
        }`,
        { center: true }
      );

      const doc = new Document({
        sections: [
          {
            properties: {},
            children: paragraphs,
          },
        ],
      });

      const blob = await Packer.toBlob(doc);
      saveAs(
        blob,
        `CONTRATO_${(
          contractData?.curp ||
          contractData?.firstName ||
          "COLABORADOR"
        ).toString()}.docx`
      );
    } catch (error) {
      console.error(error);
      notification(
        "Error",
        "Ocurrió un error al generar el archivo Word",
        "danger"
      );
    }
  };

  return { handleDownloadContractDocx };
};
